import { render, staticRenderFns } from "./view_focus.vue?vue&type=template&id=f166b018"
import script from "./view_focus.vue?vue&type=script&lang=js"
export * from "./view_focus.vue?vue&type=script&lang=js"
import style0 from "./view_focus.vue?vue&type=style&index=0&id=f166b018&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports